//External
import React, { useState } from "react";

/*******************
  @Purpose : used for features
  @Parameter : {features}
  @Author : INIC
  *******************/
function Features({ features }) {
  const [activeId, setActiveId] = useState("");

  /*******************
  @Purpose : used for toggle active
  @Parameter : {id}
  @Author : INIC
  *******************/
  function toggleActive(id) {
    if (activeId === id) {
      setActiveId(null);
    } else {
      setActiveId(id);
    }
  }

  /*******************
  @Purpose : used for concat index
  @Parameter : {val1, val2}
  @Author : INIC
  *******************/
  function concateIndex(val1, val2) {
    return val1 + "_" + val2;
  }

  const forMap = [1, 2, 3, 4];
  let options = [];

  if (features) {
    options = [];
    features.forEach(function (feature) {
      let obj = { img: feature.image, title: feature.title };
      options.push(obj);
    });
  }

  /*******************
  @purpose : Rander HTML/ React Components
  @Author : INIC
  ******************/
  return (
    <>
      <section className="featured py-75">
        <div className="custom-container">
          <div className="section-heading feature-title text-center">
            <h3 className="mb-0">Featured in</h3>
          </div>
        </div>

        <div className="logo-slider">
          {forMap.map((row0, index0) => (
            <ul className="slider-content" key={index0} id={row0}>
              {options.map((row, index) => (
                <li
                  key={index}
                  id={concateIndex(index0, index)}
                  onMouseEnter={() => toggleActive(concateIndex(index0, index))}
                  onMouseLeave={() => toggleActive(concateIndex(index0, index))}
                  className={
                    activeId === concateIndex(index0, index) ? "active" : null
                  }
                >
                  <picture>
                    <source srcSet={row?.img?.webp_w200} type="image/webp" />
                    <source srcSet={row?.img?.jpeg_w200} type="image/jpeg" />
                    <img src={row?.img?.jpeg_w200} alt={row?.title} />
                  </picture>
                </li>
              ))}
            </ul>
          ))}
        </div>
      </section>
    </>
  );
}

export default Features;
